/**
 * Fireblocks integration API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface FireblocksAssetBalance {
  fireblocksDepositVaultId?: number;
  fireblocksAssetMapId?: number;
  businessEntity?: FireblocksAssetBalance.BusinessEntityEnum;
  availableBalance?: number;
}
export namespace FireblocksAssetBalance {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
